import { Typography } from '@aloft/toolkit-sui';

import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownAdditionalStructure } from './AdjustmentBreakdownAdditionalStructure.tsx';

export const AdjustmentBreakdownAdditionalStructureBelowGradeAnsi = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <AdjustmentBreakdownAdditionalStructure
    {...props}
    breakdownCategory="belowGradeANSI"
    title="Below Grade (per ANSI)"
    id="isDepreciatedCostAdditionalImprovementsBelowGradeInExport"
    summary={props}
  >
    <Typography variant="body1">
      Below grade (per ANSI) square footage, also referred to as non-standard GLA, is square footage
      that is below grade per the ANSI measurement standard but considered to have a cost to build
      that is similar to typical above grade square footage. This adjustment is calculated by
      subtracting the comparable's below grade per ANSI value from the subject's below grade per
      ANSI value.
    </Typography>
  </AdjustmentBreakdownAdditionalStructure>
);
